import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const SLoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;
